'use client';

import {createContext, ReactNode, useState} from 'react';

type StepProviderProps = {
  children: ReactNode;
};

type StepProviderState = {
  deletingStep: string | null;
  setDeletingStep: React.Dispatch<React.SetStateAction<string | null>> | null;
};

const initialState: StepProviderState = {
  deletingStep: null,
  setDeletingStep: null,
};

export const StepProviderContext = createContext<StepProviderState>(initialState);

export const StepProvider = ({children, ...props}: StepProviderProps) => {
  const [deletingStep, setDeletingStep] = useState<string | null>(null);

  return (
    <StepProviderContext.Provider {...props} value={{deletingStep, setDeletingStep}}>
      {children}
    </StepProviderContext.Provider>
  );
};
